var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3905 5.66675L5 5.66675C4.63181 5.66675 4.33333 5.36827 4.33333 5.00008C4.33333 4.63189 4.63181 4.33342 5 4.33342L11.3905 4.33342L9.86193 2.80482C9.60158 2.54447 9.60158 2.12236 9.86193 1.86201C10.1223 1.60166 10.5444 1.60166 10.8047 1.86201L13.4714 4.52868C13.5934 4.65072 13.659 4.84028 13.6667 5.00008C13.6667 4.98942 13.6672 5.01074 13.6667 5.00008M11.3905 5.66675L9.86193 7.19534C9.60158 7.45569 9.60158 7.8778 9.86193 8.13815C10.1223 8.3985 10.5444 8.3985 10.8047 8.13815L13.4714 5.47148C13.6 5.34288 13.6651 5.16864 13.6667 5.00008",
    fill: "#8D96B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27614 10.3334L11.6667 10.3334C12.0349 10.3334 12.3333 10.6319 12.3333 11.0001C12.3333 11.3683 12.0349 11.6667 11.6667 11.6667L5.27614 11.6667L6.80474 13.1953C7.06509 13.4557 7.06509 13.8778 6.80474 14.1382C6.54439 14.3985 6.12228 14.3985 5.86193 14.1382L3.19526 11.4715C3.07322 11.3494 3.00765 11.1537 3.00003 10.9939C3.00157 10.8254 3.06665 10.6573 3.19526 10.5287L5.86193 7.86201C6.12228 7.60166 6.54439 7.60166 6.80474 7.86201C7.06509 8.12236 7.06509 8.54447 6.80474 8.80482L5.27614 10.3334Z",
    fill: "#8D96B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/ChangeIcon.20190173b59d74f28798298b4e351824.svg";
export { ForwardRef as ReactComponent };